import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import StyledTableDataCell from './StyledTableDataCell.js';

const TableDataCell = (_a) => {
    var { children, rtl, rowCellPadding } = _a, rest = __rest(_a, ["children", "rtl", "rowCellPadding"]);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const isRowMenu = rest.rowMenu;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const isStickyColumn = rest['data-sticky-td'];
    return (jsx(StyledTableDataCell, Object.assign({ component: "div" }, rest, { isRowMenu: isRowMenu, width: rest.style.width, rtl: rtl, rowCellPadding: rowCellPadding, className: isRowMenu ? 'op-row-menu-column' : '', sticky: isStickyColumn }, { children: children })));
};
TableDataCell.displayName = 'TableDataCell';

export { TableDataCell as default };
//# sourceMappingURL=TableDataCell.js.map
